import template from './freeform-filter.component.html';
import {AttributeFilterController} from '../attribute-filter.component';
import moment from 'moment';

class FreeformFilterController extends AttributeFilterController {
  constructor($filter) {
    'ngInject';
    super();
    this.translateFilter = $filter('translate');
    this.showPresets = false;
    this.showDates = true;
  }

  $onInit() {
    this.setHelp();
    this.showTimes = this.attr.rawAttr.dataType === 'Datetime';

    const {range} = this.attr.rawAttr;
    this.min = range.min ? moment(range.min).toDate() : null;
    this.max = range.max ? moment(range.max).toDate() : null;
  }

  $postLink() {
    this.setDateSelections();
  }

  setHelp() {
    let instructions = '';
    switch (this.attr.rawAttr.dataType) {
      case 'Date':
      case 'Datetime':
        instructions = 'dateRange';
        break;
      case 'Integer':
      case 'Decimal':
        instructions = 'numericRange';
        break;
      case 'Text':
        instructions = 'list';
        break;
      default:
        instructions = 'unavailable';
        break;
    }
    this.getHelp({help: instructions});
  }

  toggleAnyValue() {
    this.attr.anyValue = !this.attr.anyValue;
    this.checkDateValidation();
  }

  addValue() {
    if (this.freeformFilterForm.$valid) {
      super.addValue();
    } else {
      super.validateForm(this.freeformFilterForm);
    }
  }

  isPlainText() {
    return !this.isNumeric() && !this.isDate() && !this.isDatetime();
  }

  isNumeric() {
    const {dataType} = this.attr.rawAttr;
    return dataType === 'Integer' || dataType === 'Decimal';
  }

  isDate() {
    const {dataType} = this.attr.rawAttr;
    return dataType === 'Date';
  }

  isDatetime() {
    const {dataType} = this.attr.rawAttr;
    return dataType === 'Datetime';
  }

  getPlaceholder() {
    if (this.isNumeric()) {
      return this.translateFilter('Enter a number');
    } else {
      return this.translateFilter('Enter a filter term');
    }
  }

  getForm($index) {
    return this[`valueForm${$index}`];
  }

  getFormField($index, field) {
    return this.getForm($index)[`${field}`];
  }

  getErrorType($index) {
    if (!this.isDate() && !this.isDatetime()) {
      const parentErrorType = super.getErrorType($index);
      if (parentErrorType != null) {
        return parentErrorType;
      } else if (this.hasInvalidPattern($index)) {
        return `${this.attr.rawAttr.dataType.toLowerCase()}-pattern`;
      }
    }
  }

  hasInvalidPattern($index, field = 'value') {
    const fieldRef = this.getFormField($index, field);
    return !!fieldRef && !!fieldRef.$error && !!fieldRef.$error.pattern;
  }

  setDateSelections() {
    if (this.attr.selectedRange) {
      this.startDate = this.attr.selectedRange.min ? this.attr.selectedRange.min : '';
      this.endDate = this.attr.selectedRange.max ? this.attr.selectedRange.max : '';
    }
    this.checkDateValidation();
  }

  updateStartDate(start) {
    if (start) {
      this.attr.selectedRange.min =
        this.attr.rawAttr.dataType !== 'Datetime'
          ? moment(start)
              .toISOString()
              .slice(0, 10)
          : moment(start).toISOString();
    } else {
      delete this.attr.selectedRange.min;
    }
    this.checkDateValidation();
  }

  updateEndDate(end) {
    if (end) {
      this.attr.selectedRange.max =
        this.attr.rawAttr.dataType !== 'Datetime'
          ? moment(end)
              .startOf('day')
              .toISOString()
              .slice(0, 10)
          : moment(end).toISOString();
    } else {
      delete this.attr.selectedRange.max;
    }
    this.checkDateValidation();
  }

  checkDateValidation() {
    if (this.dynamicDates) {
      !this.attr.anyValue
        ? this.dynamicDates.$setValidity('required', Object.keys(this.attr.selectedRange).length !== 0)
        : this.dynamicDates.$setValidity('required', true);
    }
  }
}

export const freeformFilterComponent = {
  template,
  controller: FreeformFilterController,
  controllerAs: 'vm',
  bindings: {
    attr: '<',
    getHelp: '&'
  }
};
